module.exports = __webpack_public_path__ + "img/lapaireDist.e1d0634d.jpg";